import React from "react";

// reactstrap components

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import Footer from "components/Footers/Footer.js";

// index sections
import Main from "views/index-sections/Main.js";


function Index() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("index");
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <div id="top"></div>
      <IndexNavbar />
      <IndexHeader />
      <div className="main" >
          <Main />  
        <Footer />
      </div>
    </>
  );
}

export default Index;
